export default class VisitHomePageModel {
  constructor(extra) {
    this.message = '[Front-end] Visit home page';
    this.extra = extra;
  }
}
